
import { Box } from "@mui/material";

const LogoSection = ({ user }) => {

  const handleReload = () => {
    if (user) {
      window.location.href = "/home";
    } else {
      window.location.href = "/";
    }
  };


  return (
      <Box
        component="a"
        onClick={handleReload}
        sx={{ display: "flex", justifyContent: "center", cursor: "pointer" }}
      >
        <Box component="img" src="/assets/logo-red-(512x110).png" alt="logo" sx={{ height: { xs: 27, md: 30 } }} />
      </Box>
  );
};

export default LogoSection;
